'use client';

import React, { FC } from 'react';
//import Image from 'next/image';
import dynamic from 'next/dynamic';
import Image from 'next/image';

type Props = {
  className?: string;
  onClick?: () => void;
  isBeta?: boolean;
  objectFit?: string;
  borderRadius?: string;
  fill?: boolean;
  width?: number;
  height?: number;
  isThumbnail?: boolean;
};

const getIconPath = (
  isBeta: boolean,
  isThumbnail?: boolean,
  iconType?: string
): string => {
  if (iconType !== undefined && iconType !== 'LIVE' && isBeta) {
    // return '/icons/logo-without-beta.svg';
    return '/icons/beta.klic-logo.svg';
  }
  if (iconType !== undefined && iconType !== '' && isBeta) {
    return '/icons/alpha.png';
  }
  if (isThumbnail) {
    return '/icons/thumbnailForEvents.svg';
  }
  return isBeta ? '/icons/beta.klic-logo.svg' : '/icons/thumbnail.svg';
};

const LogoIcon: FC<Props> = ({
  className = '',
  onClick = () => {},
  isBeta = false,
  borderRadius = '0px',
  objectFit = 'contain',
  fill = false,
  width = 80,
  height = 66,
  isThumbnail = false,
}) => {
  const iconType = process.env.NEXT_PUBLIC_SITE_LOGO;
  const imageSrc = getIconPath(isBeta, isThumbnail, iconType);

  return (
    <Image
      onClick={onClick}
      className={className}
      src={imageSrc}
      height={height}
      width={width}
      alt={'KLıC Logo'}
      fill={fill}
      objectFit={objectFit}
      style={{
        maxWidth: '100%',
        height: 'auto',
        borderRadius,
      }}
    />
  );
};

export default LogoIcon;
